import { VStack, Text } from '@chakra-ui/react';

interface Props {
  title?: string;
}

const AuthHeader: React.FC<Props> = ({ title = '' }) => {
  return (
    <VStack gap={6} mb={4}>
      <img src='/logo.png' alt='Coach Hub' width='160px' />
      {title && (
        <Text as={'h1'} fontSize={'2xl'} fontWeight={'extrabold'}>
          {title}
        </Text>
      )}
    </VStack>
  );
};

export default AuthHeader;
